module.exports = __webpack_public_path__ + "img/back-android.b1321e9b.svg";